import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFindMyContactSearchResultModule } from './kn-br-find-my-contact-search-result/kn-br-find-my-contact-search-result.module';
import { KnBrFindMyContactSearchModule } from './kn-br-find-my-contact-search/kn-br-find-my-contact-search.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrFindMyContactSearchModule,
    KnBrFindMyContactSearchResultModule,
  ]
})
export class FindMyContactModule { }
